import { render, staticRenderFns } from "./KrausButton.vue?vue&type=template&id=5a5b285b&lang=pug&"
import script from "./KrausButton.vue?vue&type=script&lang=js&"
export * from "./KrausButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports